import { connectStreamSource, disconnectStreamSource } from "@hotwired/turbo"
import { subscribeTo } from "./cable"

// Minimal port of turbo-rails cable stream source so turbo_stream_from works with Vite.
class TurboCableStreamSourceElement extends HTMLElement {
  static observedAttributes = ["channel", "signed-stream-name"]

  connectedCallback() {
    connectStreamSource(this)
    this.subscription = subscribeTo(this.channel, {
      received: this.dispatchMessageEvent.bind(this),
      connected: () => this.setAttribute("connected", ""),
      disconnected: () => this.removeAttribute("connected"),
    })
  }

  disconnectedCallback() {
    disconnectStreamSource(this)
    if (this.subscription) this.subscription.unsubscribe()
    this.removeAttribute("connected")
  }

  attributeChangedCallback() {
    if (this.subscription) {
      this.disconnectedCallback()
      this.connectedCallback()
    }
  }

  dispatchMessageEvent(data) {
    this.dispatchEvent(new MessageEvent("message", { data }))
  }

  get channel() {
    return {
      channel: this.getAttribute("channel"),
      signed_stream_name: this.getAttribute("signed-stream-name"),
    }
  }
}

if (customElements.get("turbo-cable-stream-source") === undefined) {
  customElements.define(
    "turbo-cable-stream-source",
    TurboCableStreamSourceElement,
  )
}
